/**
 * Last-viewed product card highlight.
 *
 * - On click: stores the product ID to localStorage.
 * - On page load: finds the matching card and applies the highlight class immediately,
 *   so the border shows on back-navigation without needing a refresh.
 */

const STORAGE_KEY = 'lastViewedProductId';
const HIGHLIGHT_CLASS = 'product-grid__item--last-viewed';

function highlightLastViewed() {
  const productId = localStorage.getItem(STORAGE_KEY);
  if (!productId) return;

  const card = document.querySelector(`.product-grid__item[data-product-id="${productId}"]`);
  if (card) {
    card.classList.add(HIGHLIGHT_CLASS);
  }
}

function attachClickListeners() {
  document.querySelectorAll('.product-grid__item[data-product-id] .product-grid__card').forEach((link) => {
    link.addEventListener('click', () => {
      const item = link.closest('.product-grid__item[data-product-id]');
      if (item) {
        localStorage.setItem(STORAGE_KEY, item.dataset.productId);
      }
    });
  });
}

function refresh() {
  // Remove any existing highlight first
  document.querySelectorAll(`.${HIGHLIGHT_CLASS}`).forEach((el) => el.classList.remove(HIGHLIGHT_CLASS));
  highlightLastViewed();
  attachClickListeners();
}

// Initial load
refresh();

// bfcache restore (back/forward navigation) -- scripts don't re-run in this case,
// but pageshow fires with persisted=true, so we re-highlight here
window.addEventListener('pageshow', (event) => {
  if (event.persisted) refresh();
});

// Re-run after infinite scroll loads new cards
document.addEventListener('theme:section:load', refresh);
